import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';

const DeveloperMultiSelect = ({
  allDevelopers,
  handleDevSelection,
  handleSelectAll,
  isAllSelected,
  selectedDeveloperNames
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  // filter developers based on search term
  const filteredDevelopers = allDevelopers.filter((developer) =>
    developer.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Dropdown className="developers-multiselect-wrapper" autoClose="outside">
      <Dropdown.Toggle
        variant="select"
        id="dropdown-basic"
        style={{ width: '100%', height: '100%' }}
      >
      {selectedDeveloperNames.length > 0 ? `${selectedDeveloperNames.length} Selected` : `Select Developers`}
        
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{ maxHeight: '600px', width: '250px', overflowY: 'auto' }}
      >
        {/* Search Box */}
        <Form.Control
          type="text"
          placeholder="Search developers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: '10px' }}
        />

        {/* Select All Checkbox */}
        <Dropdown.Item as="div" onClick={handleSelectAll}>
          <Form.Check
            type="checkbox"
            id="select-all"
            checked={isAllSelected}
            label="Select All"
            onChange={() => {}}
          />
        </Dropdown.Item>

        {/* Developer List */}
        {filteredDevelopers.map((developer) => (
          <Dropdown.Item
            key={developer.value}
            as="div"
            onClick={handleDevSelection}
          >
            <Form.Check
              type="checkbox"
              id={developer.value}
              checked={!!developer.selected}
              label={developer.name}
              value={developer.value}
              onChange={() => {}}
            />
          </Dropdown.Item>
        ))}

        {/* No results */}
        {filteredDevelopers.length === 0 && (
          <div style={{ padding: '8px', color: '#777' }}>No developers found</div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

DeveloperMultiSelect.propTypes = {
  allDevelopers: PropTypes.array.isRequired,
  handleDevSelection: PropTypes.func.isRequired,
  handleSelectAll: PropTypes.func.isRequired,
  isAllSelected: PropTypes.bool.isRequired,
};

export default DeveloperMultiSelect;